import React from 'react'
import { Control } from 'react-redux-form'
import { t } from 'ttag'

import Field from '../../../form/Field'
import Form from '../../../form/Form'

const MultipleChoiceOccupationForm = ({
  onSave,
  onCancel,
  clusterOptions,
  interestOptions
}) => {
  const formModel = 'survey.surveyForms.surveyMultiChoiceOccupationForm'
  const model = path => `${formModel}.${path}`

  return (
    <Form
      model={formModel}
      onSubmit={form => {
        onSave(form)
      }}>
      {form => (
        <div>
          <Field
            model={model(`name`)}
            form={form}
            required={true}
            label={t`Question Title`}
            type="text"
          />

          <Field
            model={model(`description`)}
            form={form}
            label={t`Description`}
            type="textarea"
          />

          <Field
            model={model(`responseRequired`)}
            form={form}
            label={t`Response Required`}
            type="checkbox"
          />

          <Field
            model={model(`multipleResponses`)}
            form={form}
            label={t`Allow Multiple Responses`}
            type="checkbox"
          />

          <Field
            model={model(`noSelectionText`)}
            form={form}
            label={t`No Selection Text (eg: choose one) or blank for none`}
            type="text"
          />

          <Field
            model={model('cluster')}
            form={form}
            label={t`Primary Cluster`}
            control={Control.select}>
            <option value="">Any Cluster</option>
            {(clusterOptions || []).map(v => (
              <option key={`${v.id}--cluster`} value={v.id}>
                {v.label}
              </option>
            ))}
          </Field>
          <div className="row">
            <div className="col-xs-6">
              <Field
                model={model(`minJobZone`)}
                form={form}
                label={t`Min Job Zone`}
                control={Control.select}>
                <option value="">Any Job Zone</option>
                {(new Array(5).fill() || []).map((v, idx) => (
                  <option key={`${idx}--jzmin`} value={idx + 1}>
                    Job Zone {idx + 1}
                  </option>
                ))}
              </Field>
            </div>
            <div className="col-xs-6">
              <Field
                model={model(`maxJobZone`)}
                form={form}
                label={t`Max Job Zone`}
                control={Control.select}>
                <option value="">Any Job Zone</option>
                {(new Array(5).fill() || []).map((v, idx) => (
                  <option key={`${idx}--jzmax`} value={idx + 1}>
                    Job Zone {idx + 1}
                  </option>
                ))}
              </Field>
            </div>
          </div>
          <Field
            model={model('primaryInterest')}
            form={form}
            label={t`Primary Interest`}
            control={Control.select}>
            <option value="">Any Interest</option>
            {(interestOptions || []).map(v => (
              <option key={`${v.id}--interest`} value={v.id}>
                {v.label}
              </option>
            ))}
          </Field>
          <div className="nav" style={{ marginTop: '1em' }}>
            <input type="submit" className="submit" value={t`Save Question`} />
            &nbsp;
            <button type="button" onClick={onCancel} className="cancel">
              {t`Cancel`}
            </button>
          </div>
        </div>
      )}
    </Form>
  )
}

export default MultipleChoiceOccupationForm
